import React from 'react';
import Layout from '../../components/layout/base/index';
import PageTitle from '../../components/page-title/index';
import AlertPedidosAvaliacao from '../../components/alert-pedidos-avaliacao';
import _tableau from './_tableau';
import PageTitleCard from 'components/page-title-card';

function TesteHomeIframe() {
  return (
    <Layout>
      <PageTitleCard title="HOME" />

      <AlertPedidosAvaliacao />

      <div className="home-web d-flex">
        <_tableau />
      </div>
    </Layout>
  );
}

export default TesteHomeIframe;
